import React from "react";
import SidebarComp from "../../components/sidebar/sidebar";
import NavbarComp from "../../components/navbar/navbar";
import EditDriverMainComp from "../../components/body/editcomponent/editdriver/editdrivermaincomp";

const EditDriverScreen=()=>{
    return(
        <div className="container-scroller">
            <NavbarComp />
            <div className="container-fluid page-body-wrapper">
                <SidebarComp />
                <div className="main-panel">
                    <div className="content-wrapper">
                        <EditDriverMainComp />
                    </div>
                </div>
            </div>
        </div>
        
    )
}

export default EditDriverScreen;